
define("ch_common", function(){});
